const menu = document.querySelector('.menu-wrapper');
var menuTimeline;

document.addEventListener('cmpth:close-mobile-menu', () => {
	closeMenu();
});

export function initMenu() {
	var el = document.querySelector('.burger');
	if(!el) return;
	var close = document.querySelector('.close');
	el.addEventListener('click', openCloseMenu, false);
	close.addEventListener('click', closeMenu, false);
	menuTimelineFunction();
	var el = menu;
	var content = el.querySelectorAll('nav');

	let submenusItems = menu.querySelectorAll('.menu-item-has-children')

	submenusItems.forEach(item => {
		let t = subMenuTimelineFunction(item)
		item.addEventListener('click', (e)=>{
			const tagA = item.querySelector('a');
			if(tagA && tagA.getAttribute('href')==='#' && e.target === tagA){
				e.preventDefault();
				openCloseSubMenu(item,t)
			}
		}, false);
		
	})

}

function openCloseSubMenu(item, t) {
    let submenu = item.querySelector('.sub-menu');
    if (!item.classList.contains('opened')) {
        t.play().then(() => {
            item.classList.add('opened');
        });
    } else {

        
		t.reverse().then(() => {
			item.classList.remove('opened'); 
        });
	}
	
}

function subMenuTimelineFunction(submenu) {
	let t = gsap.timeline();
	t.to(submenu.querySelector('.sub-menu'),{
        height:'auto',
		duration:.4,
		ease:"Power2.easeInOut",
	})
	t.pause();
	return t;
	

}

function menuTimelineFunction() {
	menuTimeline = gsap.timeline();
	var el = menu;
	var links = el.querySelectorAll("li:not(.sub-menu li), .lang");
    var burgerLineV = document.querySelectorAll(".burger .v"); 
	var burgerLineH = document.querySelectorAll(".burger .h"); 
	var burgerLineM = document.querySelectorAll(".burger .m"); 
	
	menuTimeline.set(links,{
		autoAlpha:0,
		yPercent:-100,
		
	});
	
	
	menuTimeline.to(el,{
		yPercent:100,
		autoAlpha:1,
		duration:.5,
		ease:"Power2.easeOut"
	},"<")
	menuTimeline.to(links,{
		autoAlpha:1,
		yPercent:0,
		stagger:.05,
		duration:.5,
		ease:"Power2.easeOut"
	})
	menuTimeline.to(burgerLineH,{
		rotate:135,
        duration:.2,
		y:8,
		ease:"Power2.easeOut",
	})
	menuTimeline.to(burgerLineV,{
		rotate:45,
        duration:.2,
		y:-8,
		ease:"Power2.easeOut",
	},"<")
	menuTimeline.to(burgerLineM,{
		rotate:45,
		autoAlpha:0,
        duration:.2,
		ease:"Power2.easeOut",
	},"<")
	
	menuTimeline.eventCallback("onStart", function() {
		
	});
	menuTimeline.pause();
}

export function closeMenu() {
	var el = menu;
	if(!el) return;
	el.classList.remove('opened');
	document.querySelector('body').classList.remove('overHidden');
	if (menuTimeline) {
		menuTimeline.reverse();
	}
}

function openCloseMenu() {
	var el = menu;
	var content = el.querySelectorAll('nav');
	let header = document.querySelector('header')
	if (!gsap.isTweening(el) && !gsap.isTweening(content)) {
		if (!el.classList.contains('opened')) {
			el.classList.add('opened');
			header.classList.add("sticky")
			document.querySelector('body').classList.add('overHidden');
			menuTimeline.restart();
		} else {
			el.classList.remove('opened');
			document.querySelector('body').classList.remove('overHidden');
			menuTimeline.reverse().then(() => {
				if(header.classList.contains("active")) return
				header.classList.remove("sticky")
			});
		}
	}
}
